enum ParentAnswerTypeEnum {
  Fullname = "FullName",
  BirthYear = "BirthYear",
  BirthPlace = "BirthPlace",
  Profession = "Profession",
  Qualifications = "Qualifications",
  Address = "Address",
  Mobile = "Mobile",
  Email = "Email",
  ParentshipType = "ParentshipType",
}

export default ParentAnswerTypeEnum;
